import { I18nValue } from "@/components/i18n/lang-context"

// Types definition
export const COUNTRY_CODES = ['fr'] as const
export type CountryCode = typeof COUNTRY_CODES[number]

// Languages definition
export const COUNTRIES: { [key: string]: I18nValue } = {
  'fr': {fr: 'France', en: 'France'}
}

export const AREAS:  { [key: string]: I18nValue } = {
  '06': {fr: '06 - Alpes-Maritimes'},
  '13': {fr: '13 - Bouches-du-Rhônes'},
  '30': {fr: '30 - Gard'},
  '33': {fr: '33 - Gironde'},
  '67': {fr: '67 - Bas-Rhin'},
  '75': {fr: '75 - Paris'},
  '83': {fr: '83 - Var'}
}

export interface Address {
  countryCode: CountryCode
  area: string
  zipCode: string
  city: string
  addressLine: string
  latitude: number
  longitude: number
  website?: I18nValue
}

export interface Partner {
  id: string
  name: string
  type: 'real-estate' | 'finance'
  logo: string
  logoDark?: string
  logoW?: number
  logoH?: number
  website: I18nValue
  email: string
  phone: string
  location: I18nValue
  addresses: Address[]
  backgroundImages?: string[]
  description?: I18nValue
  title?: I18nValue // Pour les courtiers
}
